import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"
import Prose from "../prose"
import Button from "../button"

const Teaser = ({
  title,
  image,
  contentText,
  buttonText,
  buttonLink,
  reverseImage,
  backgroundColor,
}) => {
  const TeaserBody = ({
    title,
    image,
    contentText,
    buttonLink,
    buttonText,
  }) => {
    return (
      <article
        className={`md:flex max-w-3xl mx-auto ${
          !reverseImage ? `flex-row-reverse` : ``
        }`}
      >
        {image && <GatsbyImage className="w-full md:w-2/4" image={image} />}
        <div className="p-10 bg-white md:w-2/4">
          {title && <h2 className="mb-4">{title}</h2>}
          {contentText && <Prose content={contentText} />}
          {buttonLink && buttonText && (
            <Button url={buttonLink}>{buttonText}</Button>
          )}
        </div>
      </article>
    )
  }

  if (backgroundColor) {
    let bgColor = ""

    if (backgroundColor[0] === "Vihreä") {
      bgColor = "bg-green"
    }
    if (backgroundColor[0] === "Keltainen") {
      bgColor = "bg-yellow"
    }
    if (backgroundColor[0] === "Sininen") {
      bgColor = "bg-blue"
    }
    if (backgroundColor[0] === "Pinkki") {
      bgColor = "bg-pink"
    }

    return (
      <section
        className={`w-screen ml-[50%] translate-x-[-50%] py-12 px-5 ${bgColor}`}
      >
        <TeaserBody
          title={title}
          image={image}
          contentText={contentText}
          buttonLink={buttonLink}
          buttonText={buttonText}
        />
      </section>
    )
  } else {
    return (
      <TeaserBody
        title={title}
        image={image}
        contentText={contentText}
        buttonLink={buttonLink}
        buttonText={buttonText}
      />
    )
  }
}

Teaser.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
  contentText: PropTypes.object,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  imagePosition: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

export default Teaser
